import { render, staticRenderFns } from "./DamageInvoice.vue?vue&type=template&id=21162cb0&scoped=true&"
import script from "./DamageInvoice.vue?vue&type=script&lang=js&"
export * from "./DamageInvoice.vue?vue&type=script&lang=js&"
import style0 from "./DamageInvoice.vue?vue&type=style&index=0&id=21162cb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21162cb0",
  null
  
)

export default component.exports